module.exports = __webpack_public_path__ + "img/branches.9c2d7d96.svg";